import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './index.css';
import './styles/mobile.css';

// Build tag — emitted at entry so rollup mints a fresh entry-chunk hash when
// this changes. Last bumped 2026-05-10e+1 (CF Pages had cached a stale 404
// on the prior entry hash from a deploy-race window).
(globalThis as { __reloEntry?: string }).__reloEntry = '2026-05-10e+1';

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
